import Lookup from 'src/componentes/select2';

const CriteriosAvaliacaoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/CriteriosAvaliacaoLookup"
    clearable={false}
    {...rest}
  />
);

export default CriteriosAvaliacaoLookup;
